<div class="wrapper">
	<div class="container">
		<div class="brd_bx">
			<div class="row">
				<div class="col-lg-12">
					<div class="card m-b-30">
						<div class="card-body">
							<form action="" method="post" id="aaj_na_divse_form" enctype="multipart/form-data">
								<div class="row">
									<div class="col-lg-12">
										<div class="card m-b-10">
											<div class="page-title-box row">
												<div class="col-md-6">
													<div class="btn-group ">
														<h4 class="page-title">Shubh Divas Add - {{bhag_no}}</h4>
													</div>
												</div>
												<div class="col-md-6">
													<div class="btn-group pull-right">
														<div>
															<button (click)="submit_form()"
																class="btn btn-success waves-effect waves-light m-r-5">Save</button>
															<a href="javascript:void(0);" routerLink="/shubh-divas-list"
																type="button"
																class="btn btn-secondary waves-effect m-l-5">Cancel</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">Gujarati Title: </label>
										<div class="col-sm-8">
											<input class="form-control" data-validation="required" type="text"
												name="title" value="{{NewsData?.title}}" id="guj_title">
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">English Title: </label>
										<div class="col-sm-8">
											<input class="form-control" value="{{NewsData?.eng_title}}" type="text"
												name="eng_title" value="" id="eng_title">
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label for="image1" class="col-sm-4 col-form-label">Heading image 1: </label>
										<div class="col-sm-8">
											<input type="hidden" name="ori_image_1" value="{{NewsData?.image}}">
											<input id="image1" type="file" class="form-control" name="image_1" #file
												type="file" (change)="imageValidation($event,1)" accept='image/*'>
											<img [src]="imageURL" *ngIf="imageURL"
												style="max-width:300px;margin-top:15px">
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">Gred Line Below: </label>
										<div class="col-sm-8">
											<input class="form-control" type="text" name="gred_line_below"
												value="{{NewsData?.gred_below}}" id="gred_line_below">
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-12 row">
										<label for="guj_title" class="col-sm-2 col-form-label">Content 1: </label>
										<div class="col-sm-10">
											<ckeditor name="content1" [(ngModel)]="content1" required
												[config]="ckeConfig" debounce="500" (paste)="onPaste($event)"
												(change)="onChange($event)">
											</ckeditor>
										</div>
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">News Date: </label>
										<div class="col-sm-8">
											<input class="form-control" data-validation="required" type="text"
												name="news_date" value="{{news_date}}" id="news_date">
										</div>
									</div>
								</div>
								<input type="hidden" name="newsID" value="{{NewsData?._id}}">
								<div class="form-group row">
									<div class="col-md-6 row">
										<label class="col-sm-4 col-form-label">Display Order: </label>
										<div class="col-sm-8">
											<input type="hidden" value="{{NewsData?.display_order}}"
												name="oriDisplayOrder" id="oriDisplayOrder">
											<input type="hidden" value="{{NewsData?.bhag_no}}" name="bhag_no"
												id="bhag_no" value="{{bhag_no}}">
											<input class="form-control" value="{{NewsData?.display_order}}"
												data-validation="required number" type="text" name="display_order"
												id="display_order">
										</div>
									</div>
								</div>
								<div class="form-group">
									<div>
										<button (click)="submit_form()"
											class="btn btn-success waves-effect waves-light m-r-5">Save</button>
										<a href="javascript:void(0);" routerLink="/shubh-divas-list" type="button"
											class="btn btn-secondary waves-effect m-l-5">Cancel</a>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>